<template>
  <transition :name="fadeIn">
    <div class="jr-dialog-box" v-show="show">
      <div class="jr-dialog-mask"></div>
      <div class="jr-dialog" v-show="show">
        <div class="jr-dialog-content">
          <div class="jr-dialog-title">{{title}}</div>
          <div class="jr-text-content" v-if="content">{{content}}</div>
        </div>
        <div class="jr-dialog-btns jrm-border-1px jrm-border-top">
          <div
            v-for="(item, index) in btns"
            :key="index"
            class="js-btn jrm-border-1px jrm-border-top jr-dialog-btn"
            @click="onBtnClick(index,item)"
          >{{item.name}}</div>
        </div>
      </div>
    </div>
  </transition>
</template>
 
<script>
export default {
  props: {
    show: {
      default: false
    },
    title: {
      default: ''
    },
    content: {
      default: ''
    },
    btns: {
      type: Array,
      default: function() {
        return [
          {
            isHide: true,
            name: '我知道了'
          }
        ];
      }
    }
  },
  methods: {
    onBtnClick(index, btn = {}) {
      const { isHide } = btn;
      if (isHide) {
        this.show = false;
      }
    }
  },
  computed: {
    fadeIn() {
      return 'fadeIn';
    }
  },
  watch: {
    // show: {
    //   handler(newValue) {
    //     newValue && this.hideToast();
    //   },
    //   deep: true
    // }
  }
};
</script>
 
<style scoped lang="scss">
@import '@/scss/mixin.scss';

.jr-dialog-box {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 99999;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}

.jr-dialog-mask {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 100;
  background-color: rgba(0, 0, 0, 0.6);
  -webkit-tap-highlight-color: rgba(255, 255, 255, 0);
  -webkit-user-select: none;
  -webkit-user-drag: none;
  -webkit-transform: translate3d(0, 0, 0);
  transform: translate3d(0, 0, 0);
  -webkit-transition-property: background-color;
  transition-property: background-color;
  -webkit-transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  -webkit-transition-duration: 300ms;
  transition-duration: 300ms;
}

.jr-dialog {
  z-index: 1000;
  width: 17.5rem;
  background-color: #fff;
  -webkit-tap-highlight-color: rgba(255, 255, 255, 0);
  -webkit-user-select: none;
  -webkit-user-drag: none;
  // opacity: 0;
  border-radius: 0.0625rem;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
}

.jr-dialog-content {
  padding: 1.5rem 0;
  line-height: 1.5rem;
  font-size: 0.875rem;
  color: #666;

  .jr-dialog-title {
    font-size: 1.0625rem;
    color: #333;
    line-height: 1.8125rem;
    text-align: center;
    padding: 0 1.5rem;
  }
  .jr-text-content {
    font-size: 0.875rem;
    color: #666;
    line-height: 1.5rem;
    padding: 0.75rem 1.5rem 0;
    text-align: justify;
  }
}

.jr-dialog-btns {
  display: flex;
  flex: 0 0 1;
  flex-direction: row;

  .jr-dialog-btn {
    flex: 1;
    color: #508cee;
    font-size: 1.0625rem;
    height: 3.125rem;
    line-height: 3.125rem;
    text-align: center;
  }
}

.fadeIn-enter-active,
.fadeIn-leave-active {
  transition: opacity 0.3s;
}
.fadeIn-enter,
.fadeIn-leave-active {
  opacity: 0;
}
</style>
